module.exports = __webpack_public_path__ + "img/分享店铺.bc870a8f.svg";